import { $ } from '../../../__generated__/gql/zeus/index.ts';

// Can we find a way to make this more type safe?
// Currently we can pass any input type and it will be accepted
// export const input = (input: GraphQLVariableType): Variable<GraphQLVariableType, 'input'> => $('input', input);
export const input = $;
